module.exports = __webpack_public_path__ + "assets/img/natrium-4.189eb9ab2055f8e23db97f32363f4977.png";